export default __webpack_public_path__ + "static/media/semaforo-amarillo.3195d7bc.svg";